export const URLParser = (str: string) => {
  try {
    return new URL(str)
  } catch (e) {
    return new URL(`${window.location.origin}${str}`)
  }
}
